<template>
    <v-container>
        <h2>Search Edit</h2>
    </v-container>
</template>

<script>
export default {
    name: 'business-search-edit',
    data: () => ({}),
}
</script>
